/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamTimeSlotStateResponse } from './oralExamTimeSlotStateResponse';

export type GenericApiResponseOralExamTimeSlotStateResponseData = OralExamTimeSlotStateResponse | null;
